module.exports = __webpack_public_path__ + "img/1037277.png";